const checkImageAsync = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      resolve(img)
    }
    img.onerror = reject
    img.src = src
  })

export default checkImageAsync
